import { render, staticRenderFns } from "./RepairPartsStatistic.vue?vue&type=template&id=66c4df25"
import script from "./RepairPartsStatistic.vue?vue&type=script&lang=js"
export * from "./RepairPartsStatistic.vue?vue&type=script&lang=js"
import style0 from "./RepairPartsStatistic.vue?vue&type=style&index=0&id=66c4df25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports